goog.provide('el8.app.shared.dialog.enterpriseImportPatientFTUX');

goog.require('el8.data.practiceUsers');
goog.require('el8.ptdata.plrCollaborators');
goog.require('el8.service.urls');
goog.require('el8.template.app.shared.dialog.enterpriseImportPatientFTUX');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.consts');

/**
 * FTUX for after we imported an enterprise patient
 *
 * Two cases:
 * - Only 1 collaborator
 *   - Inform the user that the LHS has been imported 
 *   - Autosearch for all careteam and inform user they are looking at a view of the collab's docs
 *
 * - More than 1 collaborator:
 *  - Open the CP compare panel and show infotip as to why this is opened and what to do
 *  - Autosearch
 *
 */
el8.app.shared.dialog.enterpriseImportPatientFTUX = (function() {
    var lhsImported = null;

    var that = new el8.uiwidget.FormDialog({
        title: 'Getting Started with an Enterprise Chart',
        modal: true,
        autoHeight: true,
        width: 400,
        contentFn: function() {
            return el8.template.app.shared.dialog.enterpriseImportPatientFTUX.content({
                lhsImported: lhsImported,
                plrCollaborators: el8.ptdata.plrCollaborators.allAsSoyMaps()
            });
        }
    });

    var form = new el8.uiwidget.Form({
        fields: []
    });
    form.addButton('dismiss', 'Dismiss', function(_form) {
        form.disable();
        that.adjustPosition();
        el8.appchart.mainFeeds.chart.doCareteamSearch();
        that.hide();
    }, true);
    that.setForm(form);

    var super_show = that.show;
    that.show = function(spec) {
        spec = spec || {};
        lhsImported = spec.lhsImported || null;
        super_show.call(that);
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
    };

    return that;
})();
